/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import {
  Box, Button, Paper, Typography,
} from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import 'dayjs/locale/id'
// import icons from '@assets/icons'
import images from '@assets/images'
import env from '@config/env'
import application from '@config/application'
// import { matchDomain } from '@config/helpers'
import useStyles from '../Auth/Register/styles-jss/registerPayment-jss'

const Payment = (props) => {
  const classes = useStyles()
  const [listBanks, setListBanks] = useState([])
  const location = useLocation()
  const { price } = location.state || 0
  const { ewallets } = location.state || []
  const { outlets } = location.state || []
  const { paymentUrl } = location.state || ''
  const { withAvailableAccount } = location.state || ''
  const { partialPayment } = location.state || false
  const banks = location?.state?.banks || props?.banks || []
  const history = useHistory()
  useEffect(() => {
    if (partialPayment) {
      const newBanks = []
      newBanks.push(banks?.length ? banks?.[banks?.length - 1] : {})
      setListBanks(newBanks)
    } else {
      setListBanks(banks)
    }
  }, [partialPayment, banks])

  const renderActivePayment = () => (
    <div className={classes.wrapper}>
      <Paper className={classes.paper}>
        {/* {
          matchDomain(window.location.hostname)
          && (
            <img
              src={icons.AppLogo}
              height={138}
              width={110}
              alt="logo"
              className={classes.logo}
            />
          )
        } */}
        <div style={{ width: 110, height: 138 }} />

        <Typography
          variant="h6"
          className={classes.title}
          gutterBottom
        >
          Terima Kasih
        </Typography>
        <Typography
          variant="body2"
          className={classes.txDescription}
          gutterBottom
        >
          {parseInt(price?.replace(/\D/g, '')) > 0 ? 'Untuk menyelesaikan proses pembayaran, dan transfer sejumlah:' : 'Pembayaran anda telah kami proses'}
        </Typography>
        {
          parseInt(price?.replace(/\D/g, '')) > 0 && (
            <div className={classes.paperHelper}>
              <Typography
                variant="body2"
                className={classes.price}
                gutterBottom
              >
                {price}
              </Typography>

              <Paper className={classes.info}>
                <strong>Penting! </strong>
                Mohon transfer sesuai sampai dengan 3 digit terakhir
              </Paper>

              <Typography variant="caption" gutterBottom>
                Silahkan Transfer ke salah satu bank berikut:
              </Typography>
              <Box
                display="flex"
                flexDirection="column"
              >
                <Box
                  display="flex"
                  flexDirection="column"
                >
                  { listBanks?.length > 0 && <Typography>Transfer Bank:</Typography>}
                  {
                    listBanks?.length > 0 && listBanks?.map((item, index) => (
                      <Box display="flex" alignItems="flex-start" key={item.bank_name || index}>
                        <Box margin={2}>
                          <img
                            src={images[item.bank_name || item.bank || item.bank_code]}
                            alt={item.code}
                            height={32}
                            width={64}
                          />
                        </Box>
                        <Box margin={2} display="flex" flexDirection="column" flex={1}>
                          <Typography
                            style={{
                              fontSize: 16,
                              fontWeight: 'bold',
                              color: '#1C1977',
                            }}
                          >
                            {item.bank_name || item.name || item.account_holder_name}
                          </Typography>
                          <Typography style={{ fontSize: 14 }}>
                            {item.name}
                          </Typography>
                          <Typography style={{ fontSize: 14 }}>
                            {item.account_number || item.number || item.bank_account_number}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  }
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                >
                  {ewallets?.length > 0 && <Typography>Transfer E - Wallet:</Typography>}
                  {
                    ewallets?.length > 0 && ewallets?.map((item, index) => (
                      <Box display="flex" alignItems="flex-start" key={index}>
                        <Box margin={2}>
                          <img
                            src={images[item.ewallet_type]}
                            alt={item.code}
                            height={64}
                            width={64}
                          />
                        </Box>
                        <Box margin={2} display="flex" flexDirection="column" flex={1}>
                          <Typography
                            style={{
                              fontSize: 16,
                              fontWeight: 'bold',
                              color: '#1C1977',
                            }}
                          >
                            {item.ewallet_type}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  }
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                >
                  {outlets?.length > 0 && <Typography>Retail Outlet:</Typography>}
                  {
                    outlets?.length > 0 && outlets?.map((item, index) => (
                      <Box display="flex" alignItems="flex-start" key={index}>
                        <Box margin={2}>
                          <img
                            src={images[item.retail_outlet_name]}
                            alt={item.code}
                            height={64}
                            width={64}
                          />
                        </Box>
                        <Box margin={2} display="flex" flexDirection="column" flex={1}>
                          <Typography
                            style={{
                              fontSize: 16,
                              fontWeight: 'bold',
                              color: '#1C1977',
                            }}
                          >
                            {item.retail_outlet_name}
                          </Typography>
                          <Typography style={{ fontSize: 14 }}>
                            {item.payment_code}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  }
                </Box>
              </Box>
            </div>
          )
        }

        <Button
          color="primary"
          style={{ marginTop: 16, width: 220 }}
          variant="contained"
          onClick={() => history.goBack()}
        >
          Kembali ke halaman awal
        </Button>
        {
          paymentUrl && (env.applicationStage === 'development' || env.applicationStage === 'staging')
          && (
          <Button
            color="secondary"
            style={{ marginTop: 16, width: 220 }}
            variant="contained"
            onClick={() => window.open(paymentUrl, '_blank')}
          >
            Proses Pembayaran
          </Button>
          )
        }
        {
          withAvailableAccount && withAvailableAccount === 'available_account'
          && (
          <Button
            color="warning"
            style={{ marginTop: 16, width: 220 }}
            variant="contained"
            onClick={() => history.push(`${application.basePath}/dashboard`)}
          >
            Masuk Ke Dashboard
          </Button>
          )
        }
      </Paper>
    </div>
  )

  return (
    <Box className={classes.root}>
      <Helmet>
        <title>{`${window.location.host} - Payment`}</title>
      </Helmet>
      {renderActivePayment()}
    </Box>
  )
}

export default Payment
